import {actionIds, BaseAction} from "../common";

const errorAccessDeniedAction: () =>
    BaseAction = () => ({
    type: actionIds.ERROR_ACCESS_DENIED,
    payload: {},
});

export default errorAccessDeniedAction;
